import { render, staticRenderFns } from "./CustomCursor.vue?vue&type=template&id=6bafc874"
import script from "./CustomCursor.vue?vue&type=script&lang=ts"
export * from "./CustomCursor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports